module.exports = __webpack_public_path__ + "img/germany.5c9661f6.svg";